// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
  const newsBlocks = document.querySelectorAll('.news-block__grid');

  newsBlocks.forEach((block) => {
    let swiperInstance = null;
    const wrapper = block.querySelector('.news-block__wrapper');
    const slides = block.querySelectorAll('.news-block__item');

    const initSwiper = () => {
      if (window.innerWidth < 768 && !swiperInstance) {
        // Ajouter les classes Swiper
        block.classList.add('swiper');
        wrapper.classList.add('swiper-wrapper');
        slides.forEach((slide) => slide.classList.add('swiper-slide'));

        // Initialiser Swiper
        swiperInstance = new Swiper(block, {
          modules: [Navigation],
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: block.parentElement.querySelector(
              '.news-block__nav-btn--next'
            ),
            prevEl: block.parentElement.querySelector(
              '.news-block__nav-btn--prev'
            ),
          },
          a11y: {
            enabled: true,
          },
        });
      } else if (window.innerWidth >= 768 && swiperInstance) {
        // Détruire Swiper
        swiperInstance.destroy(true, true);
        swiperInstance = null;

        // Retirer les classes Swiper
        block.classList.remove('swiper');
        wrapper.classList.remove('swiper-wrapper');
        slides.forEach((slide) => slide.classList.remove('swiper-slide'));
      }
    };

    // Initialize on load
    initSwiper();

    // Re-initialize on resize with debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSwiper, 250);
    });
  });
});
